// Target only jump links within the header
const headerElement = document.querySelector('header, [header-menu], .header');
const headerDrawer = document.querySelector('header-drawer');
const headerHeight = headerElement ? headerElement.getBoundingClientRect().height : 80;

if (headerElement) {
  headerElement.querySelectorAll('a').forEach(anchor => {
    if (!anchor || !anchor.href || !anchor.href.includes('#shopify-section-')) return;

    anchor.addEventListener('click', function(e) {
      e.preventDefault();

      const anchorLink = e.target;
      const targetId = anchorLink && anchorLink.href ? anchorLink.href.split('#')[1] : null;
      const targetElement = document.getElementById(targetId);

      if (anchorLink.id && anchorLink.id.startsWith('HeaderDrawer')) {
        headerDrawer.close();
      }

      if (targetElement) {
        const elementPosition = targetElement.getBoundingClientRect().top + window.pageYOffset;
        const offsetPosition = elementPosition - headerHeight;

        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth'
        });
      } else if (targetId) {
        // Navigate to the page with scroll target as URL parameter
        const urlWithoutHash = anchor.href.split('#')[0];
        if (urlWithoutHash) {
          const url = new URL(urlWithoutHash, window.location.origin);
          url.searchParams.set('scrollTo', targetId);
          window.location.href = url.toString();
        }
      }
    });
  });
}

// Handle scrolling on page load when redirected with scrollTo parameter
document.addEventListener('DOMContentLoaded', function() {
  const urlParams = new URLSearchParams(window.location.search);
  const scrollToId = urlParams.get('scrollTo');

  if (scrollToId) {
    const targetElement = document.getElementById(scrollToId);
    const headerElement = document.querySelector('header, [header-menu], .header');
    const headerHeight = headerElement ? headerElement.getBoundingClientRect().height : 80;

    if (targetElement) {
      // Small delay to ensure page is fully loaded
      setTimeout(() => {
        const elementPosition = targetElement.getBoundingClientRect().top + window.pageYOffset;
        const offsetPosition = elementPosition - headerHeight;

        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth'
        });

        // Clean URL by removing the scrollTo parameter
        const cleanUrl = new URL(window.location.href);
        cleanUrl.searchParams.delete('scrollTo');
        window.history.replaceState({}, '', cleanUrl.toString());
      }, 100);
    }
  }
});
